import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ScrollServiceService {

  private isScrollToBottom: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isScrollToBottom$ = this.isScrollToBottom.asObservable();

  private isDataEnded: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isDataEnded$ = this.isDataEnded.asObservable();

  constructor() { }

  updateScrollStatus(isBottom: boolean) {

    this.isScrollToBottom.next(isBottom)

  }

  update_DataStatus(isEnded: boolean) {

    this.isDataEnded.next(isEnded)

  }
  
}
